import revive_payload_client_4sVQNw7RlN from "/tmp/build/38bfee86/code/node_modules/nuxt/dist/app/plugins/revive-payload.client.js";
import unhead_KgADcZ0jPj from "/tmp/build/38bfee86/code/node_modules/nuxt/dist/head/runtime/plugins/unhead.js";
import router_jmwsqit4Rs from "/tmp/build/38bfee86/code/node_modules/nuxt/dist/pages/runtime/plugins/router.js";
import _0_siteConfig_9gMxCtyFUG from "/tmp/build/38bfee86/code/node_modules/nuxt-site-config/dist/runtime/plugins/0.siteConfig.mjs";
import payload_client_yVLowv6hDl from "/tmp/build/38bfee86/code/node_modules/nuxt/dist/app/plugins/payload.client.js";
import check_outdated_build_client_8vK7RkfGxZ from "/tmp/build/38bfee86/code/node_modules/nuxt/dist/app/plugins/check-outdated-build.client.js";
import plugin_vue3_A0OWXRrUgq from "/tmp/build/38bfee86/code/node_modules/@pinia/nuxt/dist/runtime/plugin.vue3.mjs";
import components_plugin_KR1HBZs4kY from "/tmp/build/38bfee86/code/.nuxt/components.plugin.mjs";
import prefetch_client_5tzzN0oIVL from "/tmp/build/38bfee86/code/node_modules/nuxt/dist/pages/runtime/plugins/prefetch.client.js";
import performance_client_OXWUsvTdFu from "/tmp/build/38bfee86/code/node_modules/nuxt-bugsnag/dist/runtime/client/performance.client.js";
import plugin_adVF2uRka6 from "/tmp/build/38bfee86/code/node_modules/nuxt-bugsnag/dist/runtime/client/plugin.js";
import plugin_tbFNToZNim from "/tmp/build/38bfee86/code/node_modules/@zadigetvoltaire/nuxt-gtm/dist/runtime/plugin.mjs";
import plugin_ghbUAjaD3n from "/tmp/build/38bfee86/code/node_modules/@nuxtjs/device/dist/runtime/plugin.js";
import plugin_client_xSLIPjreZL from "/tmp/build/38bfee86/code/node_modules/nuxt-meta-pixel/dist/runtime/plugin.client.mjs";
import plugin_client_UYiXMU8ZyN from "/tmp/build/38bfee86/code/node_modules/nuxt-gtag/dist/runtime/plugin.client.js";
import i18n_Fspu1Dj02B from "/tmp/build/38bfee86/code/node_modules/nuxt-site-config/dist/runtime/plugins/i18n.mjs";
import plugin_8SbxDRbG6Y from "/tmp/build/38bfee86/code/node_modules/dayjs-nuxt/dist/runtime/plugin.mjs";
import i18n_yfWm7jX06p from "/tmp/build/38bfee86/code/node_modules/@nuxtjs/i18n/dist/runtime/plugins/i18n.mjs";
import colors_244lXBzhnM from "/tmp/build/38bfee86/code/node_modules/@nuxt/ui/dist/runtime/plugins/colors.mjs";
import plugin_client_i8AMfKeYnY from "/tmp/build/38bfee86/code/node_modules/@nuxtjs/color-mode/dist/runtime/plugin.client.mjs";
import chunk_reload_client_UciE0i6zes from "/tmp/build/38bfee86/code/node_modules/nuxt/dist/app/plugins/chunk-reload.client.js";
import plugin_1UohGbtF8v from "/tmp/build/38bfee86/code/node_modules/@pinia-plugin-persistedstate/nuxt/dist/runtime/plugin.mjs";
import clickOutside_C8jIyDRU4O from "/tmp/build/38bfee86/code/plugins/clickOutside.js";
import recaptcha_client_ElRG0N5AcO from "/tmp/build/38bfee86/code/plugins/recaptcha.client.ts";
import telinput_elihmOrlRL from "/tmp/build/38bfee86/code/plugins/telinput.js";
import tiktok_pixel_oIqcecOuPn from "/tmp/build/38bfee86/code/plugins/tiktok-pixel.js";
export default [
  revive_payload_client_4sVQNw7RlN,
  unhead_KgADcZ0jPj,
  router_jmwsqit4Rs,
  _0_siteConfig_9gMxCtyFUG,
  payload_client_yVLowv6hDl,
  check_outdated_build_client_8vK7RkfGxZ,
  plugin_vue3_A0OWXRrUgq,
  components_plugin_KR1HBZs4kY,
  prefetch_client_5tzzN0oIVL,
  performance_client_OXWUsvTdFu,
  plugin_adVF2uRka6,
  plugin_tbFNToZNim,
  plugin_ghbUAjaD3n,
  plugin_client_xSLIPjreZL,
  plugin_client_UYiXMU8ZyN,
  i18n_Fspu1Dj02B,
  plugin_8SbxDRbG6Y,
  i18n_yfWm7jX06p,
  colors_244lXBzhnM,
  plugin_client_i8AMfKeYnY,
  chunk_reload_client_UciE0i6zes,
  plugin_1UohGbtF8v,
  clickOutside_C8jIyDRU4O,
  recaptcha_client_ElRG0N5AcO,
  telinput_elihmOrlRL,
  tiktok_pixel_oIqcecOuPn
]